import { Link } from "react-router-dom";
import { Droplets, Truck, ShieldCheck, Phone, Mail, MapPin, RotateCcw } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-slate-950 text-slate-300" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:grid-cols-2 sm:px-6 lg:grid-cols-5 lg:px-8">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary text-white">
              <Droplets className="h-5 w-5" />
            </span>
            <span className="font-heading text-xl font-extrabold text-white">
              Clar<span className="text-accent">Wash</span>
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            Detergenți și balsam de rufe profesionali. Curățenie garantată, texturi fine și moi,
            la cel mai bun preț.
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-white">Magazin</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/magazin" className="hover:text-white">Toate produsele</Link></li>
            <li><Link to="/magazin?category=Detergenți" className="hover:text-white">Detergenți</Link></li>
            <li><Link to="/magazin?category=Balsam de rufe" className="hover:text-white">Balsam de rufe</Link></li>
            <li><Link to="/magazin?category=Pachete promo" className="hover:text-white">Pachete promo</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-white">Avantaje</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-center gap-2"><Truck className="h-4 w-4 text-accent" /> Transport gratuit la toate comenzile</li>
            <li className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-accent" /> Curățenie garantată</li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-white">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-accent" /> 0750 295 264</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-accent" /> cosmindanuu@gmail.com</li>
            <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-accent" /> Aleea Ștrandului, Tecuci, jud. Galați</li>
            <li className="text-slate-400">Nicobrand S.R.L. · CUI 51705790 · J2025030277002</li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-white">Informații legale</h4>
          <ul className="mt-4 space-y-2 text-sm" data-testid="footer-legal-links">
            <li><Link to="/termeni-si-conditii" className="hover:text-white" data-testid="footer-terms">Termeni și condiții</Link></li>
            <li><Link to="/confidentialitate" className="hover:text-white" data-testid="footer-privacy">Confidențialitate (GDPR)</Link></li>
            <li><Link to="/politica-cookies" className="hover:text-white" data-testid="footer-cookies">Politica de cookie-uri</Link></li>
            <li><Link to="/politica-retur" className="hover:text-white" data-testid="footer-returns">Politica de retur</Link></li>
            <li><Link to="/politica-livrare" className="hover:text-white" data-testid="footer-shipping">Politica de livrare</Link></li>
            <li><Link to="/protectia-consumatorului" className="hover:text-white" data-testid="footer-anpc">Protecția consumatorului</Link></li>
          </ul>
        </div>
      </div>

      {/* ANPC mandatory banners (SAL & SOL) */}
      <div className="border-t border-slate-800">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-4 px-4 py-6 sm:px-6 lg:px-8" data-testid="anpc-banners">
          <a
            href="https://anpc.ro/ce-este-sal/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="anpc-sal-banner"
            aria-label="ANPC - Soluționarea Alternativă a Litigiilor"
          >
            <img src="/anpc-sal.webp" alt="ANPC SAL - Soluționarea Alternativă a Litigiilor" width="250" height="50" className="h-[50px] w-[250px] max-w-full object-contain" loading="lazy" />
          </a>
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="anpc-sol-banner"
            aria-label="Soluționarea Online a Litigiilor"
          >
            <img src="/anpc-sol.webp" alt="ANPC SOL - Soluționarea Online a Litigiilor" width="250" height="50" className="h-[50px] w-[250px] max-w-full object-contain" loading="lazy" />
          </a>
        </div>
      </div>

      <div className="border-t border-slate-800 py-6 text-center text-xs text-slate-500">
        <Link
          to="/politica-retur"
          className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-600 px-5 py-2 text-sm font-medium text-slate-200 transition-colors hover:border-accent hover:bg-accent hover:text-white"
          data-testid="footer-return-button"
        >
          <RotateCcw className="h-4 w-4" /> Retur produse (14 zile)
        </Link>
        <p>© {new Date().getFullYear()} ClarWash by Nicobrand S.R.L. Toate drepturile rezervate. Plată ramburs la livrare.</p>
      </div>
    </footer>
  );
};
